import { Component, OnInit } from '@angular/core';
import { GuestDataComponent } from 'src/app/shared/components/guest-data/guest-data.component';
import { GuestService } from 'src/app/shared/services/guest.service';

@Component({
    selector: 'app-activity-summary',
    templateUrl: './activity-summary.component.html',
    styleUrls: ['./activity-summary.component.scss'],
    standalone: false
})
export class ActivitySummaryComponent implements OnInit {
  currentComponent = GuestDataComponent;
  selectedIndex: any;
  constructor(private gs: GuestService) {
    this.gs.TabChange$.subscribe(data => {
      this.selectedIndex = data;
    })
   }

  ngOnInit(): void {

    return;
  }

}

